<template>
    <div class="register__step" data-step="interests" v-bind:class="{'active': $store.state.step == 'interests'}">
        <h3>Interests</h3>
        <p>Our system can help match you up with what you're looking for. Tell us what you're interested in, and we'll do the rest!</p>

        <fieldset class="register__step-fieldset">
            <legend>I am interested in&hellip;</legend>

            <ul class="register__step-fields">
                <li class="register__step-field">
                    <br />
                </li>

                <li class="register__step-field register__step-field--bright">
                    <ol class="register__step-field-selections register__step-field-selections--dvc">
                        <li class="register__step-field-selection">
                            <input type="checkbox" name="register_interests" id="register_interest_dvc_buy" value="dvc_buy" v-model="$store.state.signup.interests">
                            <label for="register_interest_dvc_buy" class="register__step-field-label">Buy</label>
                        </li>
                        <li class="register__step-field-selection last">
                            <input type="checkbox" name="register_interests" id="register_interest_dvc_swap" value="dvc_swap" v-model="$store.state.signup.interests">
                            <label for="register_interest_dvc_swap" class="register__step-field-label">Swap DVC</label>
                        </li>
                        <li class="register__step-field-selection">
                            <input type="checkbox" name="register_interests" id="register_interest_dvc_sell" value="dvc_sell" v-model="$store.state.signup.interests">
                            <label for="register_interest_dvc_sell" class="register__step-field-label">Sell</label>
                        </li>
                        <li class="register__step-field-selection last">
                            <input type="checkbox" name="register_interests" id="register_interest_dvc_swap_other" value="dvc_swap_other" v-model="$store.state.signup.interests">
                            <label for="register_interest_dvc_swap_other" class="register__step-field-label">Swap DVC</label>
                        </li>
                        <li class="register__step-field-selection">
                            <input type="checkbox" name="register_interests" id="register_interest_dvc_rent" value="dvc_rent" v-model="$store.state.signup.interests">
                            <label for="register_interest_dvc_rent" class="register__step-field-label">Rent</label>
                        </li>
                    </ol>
                </li>

                <li class="register__step-field">
                    <br />
                </li>

                
                <!-- <li class="register__step-field register__step-field--bright">
                    <ol class="register__step-field-selections register__step-field-selections--mvc">
                        <li class="register__step-field-selection">
                            <input type="checkbox" name="register_interests" id="register_interest_mvc_buy" value="mvc_buy" v-model="$store.state.signup.interests">
                            <label for="register_interest_mvc_buy" class="register__step-field-label">Buy</label>
                        </li>
                        <li class="register__step-field-selection">
                            <input type="checkbox" name="register_interests" id="register_interest_mvc_sell" value="mvc_sell" v-model="$store.state.signup.interests">
                            <label for="register_interest_mvc_sell" class="register__step-field-label">Sell</label>
                        </li>
                        <li class="register__step-field-selection">
                            <input type="checkbox" name="register_interests" id="register_interest_mvc_rent" value="mvc_rent" v-model="$store.state.signup.interests">
                            <label for="register_interest_mvc_rent" class="register__step-field-label">Rent</label>
                        </li>
                        <li class="register__step-field-selection last">
                            <input type="checkbox" name="register_interests" id="register_interest_mvc_swap_other" value="mvc_swap_other" v-model="$store.state.signup.interests">
                            <label for="register_interest_mvc_swap_other" class="register__step-field-label">Swap (MVC <i class="fal fa-arrow-circle-right" aria-hidden="true"></i> DVC)</label>
                        </li>
                    </ol>
                </li> -->

                <li class="register__step-field">
                    <br />
                </li>
            </ul>
        </fieldset>

        <br />

        <footer class="register__step-footer">
            <button class="btn btn-secondary" data-direction="back" v-on:click="$store.dispatch( 'step_control', { to: 'about' } );"><i class="fas fa-chevron-left" aria-hidden="true"></i> Back</button>
            <button class="btn btn-primary" data-direction="next" v-on:click="$store.dispatch( 'step_control', { to: 'membership' } );">Next <i class="fas fa-chevron-right" aria-hidden="true"></i></button>
        </footer>
    </div>
</template>

<script>
export default {
    name: "DVCARegisterInterests"
}
</script>
